class CombiningWidgets {
    constructor() {
        this.widgets = [];
        this.isExpanded = false;
        this.toggleButton = null;
        this.icons = {};
    }

    async init() {
        if (document.readyState === 'loading') {
            await new Promise((resolve) => {
                document.addEventListener('DOMContentLoaded', resolve);
            });
        }

        await this._waitForUIS();

        this._collectWidgets();
        if (this.widgets.length) {
            this._setInitialPositions();
            this._renderToggleButton();
        }
    }

    // eslint-disable-next-line require-await
    async _waitForUIS() {
        return new Promise((resolve) => {
            const script = document.querySelector('script[src*="uiscom.ru"]');

            if (!script) {
                resolve();

                return;
            }

            if (script.hasAttribute('data-loaded')) {
                resolve();
            } else {
                const onLoad = () => {
                    script.removeEventListener('load', onLoad);
                    script.removeEventListener('error', onLoad);
                    script.setAttribute('data-loaded', 'true');
                    resolve();
                };

                script.addEventListener('load', onLoad);
                script.addEventListener('error', onLoad);

                // Таймаут на случай проблем с загрузкой
                setTimeout(resolve, 5000);
            }
        });
    }

    _collectWidgets() {
        const comagicBtn = document.querySelector('.comagic-c-buttons');
        const callTouchFrame = document.querySelector('#CalltouchWidgetFrame');

        if (comagicBtn) {
            this.widgets.push(comagicBtn);
        }
        if (callTouchFrame) {
            this.widgets.push(callTouchFrame);
        }
    }

    _setInitialPositions() {
        this.widgets.forEach((widget) => {
            widget.classList.add('group-widget');
        });
    }

    _renderToggleButton() {
        if (document.querySelector('.combining-widgets')) {
            return;
        }

        this.toggleButton = document.createElement('div');
        this.toggleButton.className = 'combining-widgets';

        this.icons.open = this._createIcon('/images/picture/combining-widgets-icon.svg');
        this.icons.close = this._createIcon('/images/picture/combining-widgets-close.svg', true);

        this.toggleButton.append(this.icons.open, this.icons.close);
        this.toggleButton.addEventListener('click', () => {
            return this._toggleWidgets();
        });

        document.body.appendChild(this.toggleButton);
    }

    _createIcon(src, hidden = false) {
        const img = document.createElement('img');

        img.src = src;
        img.alt = 'icon';
        img.className = `combining-widgets__icon${hidden ? ' hidden' : ''}`;

        return img;
    }

    _toggleWidgets() {
        this.isExpanded = !this.isExpanded;

        this.widgets.forEach((widget) => {
            widget.classList.toggle('active');
        });

        this.icons.open.classList.toggle('hidden');
        this.icons.close.classList.toggle('hidden');
    }
}

// Автоматическая инициализация при загрузке страницы
// eslint-disable-next-line func-style
async function initializeCombiningWidgets() {
    try {
        const widgetManager = new CombiningWidgets();

        await widgetManager.init();
    } catch (error) {
        console.error('Failed to initialize CombiningWidgets:', error);
    }
}

initializeCombiningWidgets();

export default CombiningWidgets;
